import type { ClientPropertyVehicleDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { PropertyOptionalParam } from "web_myplann/Portfolio/Hooks/useGetPropertyOptionalParams";

const PageResources = Resources.PortfolioDetail;

export const CAR_SECURITY_TYPES: PropertyOptionalParam<ClientPropertyVehicleDetailResponseDTO>[] =
	[
		{ key: "carAlarmSecurity", label: PageResources.Property.CarAlarmSecurity },
		{
			key: "carActiveTrackingSecurity",
			label: PageResources.Property.CarActiveTrackingSecurity,
		},
		{
			key: "carPassiveTrackingSecurity",
			label: PageResources.Property.CarPassiveTrackingSecurity,
		},
		{
			key: "carMechanicalSecurity",
			label: PageResources.Property.CarMechanicalSecurity,
		},
		{
			key: "carImmobilizerSecurity",
			label: PageResources.Property.CarImmobilizerSecurity,
		},
		{
			key: "carGlassEtchingSecurity",
			label: PageResources.Property.CarGlassEtchingSecurity,
		},
	];
